import { useState, useEffect } from "react";
import axios, { AxiosRequestConfig } from "axios";
import Helpers from "@utils/Helpers";
import { errorLog } from "logging";
import userApi from "services/UserApi";

interface FetchState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

export const useAddress = () => {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: null,
  });

  const updateAddress = async (
    address: any,
    funcCallBack: (response: any) => void
  ) => {
    try {
      const response = await userApi.updateAddress(address);
      if (response.status === 200) {
        funcCallBack(response);
      }
    } catch (error) {
      Helpers.notification.error("Cannot update address. Please try again");
      errorLog("Addresses.tsx - handleUpdateAddress", error);
    }
  };

  const addAddress = async (
    address: any,
    funcCallBack: (response: any) => void
  ) => {
    try {
      const response = await userApi.addAddress(address);
      if (response.status === 200) {
        funcCallBack(response);
      }
    } catch (error) {
      Helpers.notification.error("Cannot add address. Please try again");
      errorLog("Addresses.tsx - handleAddAddress", error);
    }
  };

  const deleteAddress = async (
    address: any,
    funcCallBack: (response: any) => void
  ) => {
    try {
      const response = await userApi.deleteAddress({
        address_id: address.address_id,
      });
      if (response.status === 200) {
        funcCallBack(response);
      }
    } catch (error: any) {
      if (error.status === 400) {
        Helpers.notification.error(error.response.data.message);
      } else {
        Helpers.notification.error("Cannot delete address. Please try again");
        errorLog("Addresses.tsx - handleDeleteAddress", error);
      }
    }
  };

  return { state, updateAddress, addAddress, deleteAddress };
};